import {
  View,
  Text,
  Image,
  Dimensions,
  TouchableOpacity,
  TextInput,
  KeyboardAvoidingView,
} from "react-native";
import React, { useEffect, useState } from "react";
import MyView from "../../components/custom/MyView";
import {
  gray,
  kalbasiMaybe,
  lightBlue,
  lighterBlue,
  orange,
  primary,
  success,
  white,
} from "../../colors";
import { consultationDoctor, kidsWithDoctor } from "../../imports";
import MyText from "../../components/custom/MyText";
import { RefreshControl, ScrollView } from "react-native-gesture-handler";
import WelcomeUser from "../../components/home/WelcomeUser";
import translate from "../../functions/translate";
import Wallet from "../../components/home/Wallet";
import GrowTest from "../../components/home/GrowTest";
import ASQ3Test from "../../components/home/ASQ3Test";
import ASQSE2Test from "../../components/home/ASQSE2Test";
import ADHDTest from "../../components/home/ADHDTest";
import LearningSlider from "../../components/home/LearningSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import SelectIcon from "../../assets/svg/SelectIcon";
import MyButton from "../../components/custom/MyButton";
import { LinearGradient } from "expo-linear-gradient";
import SectionDropdown from "../../components/custom/SectionDropdown";
import { AntDesign } from "@expo/vector-icons";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Dropdown from "../../components/custom/Dropdown";
import DoctorCard from "../../components/consultation/DoctorCard";
import { refresh } from "../../redux/main/mainAction";
import getListOfDoctors from "../../api/consultation/getListOfDoctors";
import getListOfExpertise from "../../api/consultation/getListOfExpertise";
import getDoctorConsultations from "../../api/consultation/getDoctorConsultations";
import ChatCard from "../../components/consultation/ChatCard";
import { io } from "socket.io-client";
import getToken from "../../api/token";

export default function Consultation({ route }) {
  const [selectedType, setType] = useState("new");
  const { params } = route;
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const navigation = useNavigation();
  const [doctors, setDoctors] = useState([]);
  const [consultations, setConsultations] = useState({
    new: [],
    consulting: [],
    closed: [],
  });
  const [searchButton, searchButtonChanged] = useState(true);
  const [expertiseList, setExpertise] = useState([
    { nameEn: "", nameFa: "همه" },
  ]);
  const [searchDetail, setSearchDetail] = useState({
    searchKey: "",
    expertise: "",
  });

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(lighterBlue));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);
  useEffect(() => {
    if (isFocused) {
      getDoctorConsultations()
        .then(({ data }) => {
          //if (data.status === 200) setConsultations(data.data);
          setConsultations(data.data);
    
        })
        .catch((err) => {});
    }
  }, [isFocused]);

  useEffect(() => {
    getDoctorConsultations()
      .then(({ data }) => {
        //if (data.status === 200) setConsultations(data.data);
        setConsultations(data.data);
      
      })
      .catch((err) => {});
  }, [main.refresh, searchDetail, searchButton]);

  useEffect(() => {
    const socket = io("https://api.asqtest.ir");
    socket.connect();

    socket.on("connect", (message) => {
      socket.emit("connectedDoctor", { token: getToken() });
    });

    socket.on("newMassage", (message) => {
      getDoctorConsultations()
        .then(({ data }) => {
          //if (data.status === 200) setConsultations(data.data);
          setConsultations(data.data);
        })
        .catch((err) => {});
    });
    return () => {
      socket.close("newMessage");
    };
  }, []);

  return (
    <KeyboardAwareScrollView
      enableOnAndroid
      extraHeight={100}
      refreshControl={
        <RefreshControl
          refreshing={false}
          onRefresh={() => {
            dispatch(refresh());
          }}
        />
      }
    >
      <View style={{ alignItems: "center" }}>
        <View style={{ flexDirection: "row" }}>
          {/* <View style={{ flex: 5 }}>
            <View
              title={translate("specialties")}
              textColor={white}
              backgroundColor={kalbasiMaybe}
              style={{
                padding: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <View style={{ marginTop: 5, alignItems: "center" }}>
                <MyText>{translate("consultation list")}</MyText>
              </View>
            </View>
          </View> */}
        </View>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={{
            width: "100%",

            paddingHorizontal: 20,
            marginTop: 10,
          }}
        >
          <MyButton
            onPress={() => setType("new")}
            style={{
              backgroundColor: selectedType === "new" ? orange : white,
              borderColor: orange,
              borderWidth: 1,
              marginHorizontal: 5,
            }}
            textStyle={{ color: selectedType === "new" ? white : orange }}
            text="جدید"
          />
          <MyButton
            onPress={() => setType("consulting")}
            style={{
              backgroundColor: selectedType === "consulting" ? orange : white,
              borderColor: orange,
              borderWidth: 1,
              marginHorizontal: 5,
            }}
            textStyle={{
              color: selectedType === "consulting" ? white : orange,
            }}
            text="در حال انجام"
          />
          <MyButton
            onPress={() => setType("answered")}
            style={{
              backgroundColor: selectedType === "answered" ? orange : white,
              borderColor: orange,
              borderWidth: 1,
              marginHorizontal: 5,
            }}
            textStyle={{
              color: selectedType === "answered" ? white : orange,
            }}
            text="پاسخ داده شده"
          />
          <MyButton
            onPress={() => setType("closed")}
            style={{
              backgroundColor: selectedType === "closed" ? orange : white,
              borderColor: orange,
              borderWidth: 1,
              marginHorizontal: 5,
            }}
            textStyle={{ color: selectedType === "closed" ? white : orange }}
            text="پایان یافته"
          />
        </ScrollView>
        <View style={{ marginTop: 10, width: "94%" }}>
          {consultations[selectedType].length === 0 && (
            <View
              style={{ marginTop: 20, width: "100%", alignItems: "center" }}
            >
              <MyText>موردی یافت نشد</MyText>
            </View>
          )}
          {consultations[selectedType].map((consultation, index) => (
            <ChatCard
              type={selectedType}
              key={index}
              name={consultation.name}
              lastName={consultation.lastName}
              unreadCount={consultation.countNotRead}
              image={consultation.picURL}
              id={consultation.counselingId}
            />
          ))}
        </View>
      </View>
      <View style={{ height: 100 }}></View>
    </KeyboardAwareScrollView>
  );
}
